var path = '/ui/loader/uiLoader.tpl.html';
var html = "<div ng-if=\"viewModel.isLoading\" class=\"loaderContainer\" ng-class=\"type\">\n    <div class=\"loader\" ng-class=\"{'icon-dotsSpinnerDark':type==='dark', 'icon-dotsSpinnerLight':type==='light'}\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;